import {valibotRetrieveNonsensitiveOnlySchema} from 'src/schema/valibot';

import type {StandardSchemaV1} from '@standard-schema/spec';
import type {Processed, ProcessedNonsensitiveOnly} from 'src/schema/types';
import type {InferInput, InferOutput} from 'src/types';

export type NonsensitiveOnlySchema<TSchema extends StandardSchemaV1> =
  StandardSchemaV1<
    Processed<InferInput<TSchema>>,
    ProcessedNonsensitiveOnly<InferOutput<TSchema>>
  >;

export type AllSchema<TSchema extends StandardSchemaV1> = StandardSchemaV1<
  Processed<InferInput<TSchema>>,
  Processed<InferOutput<TSchema>>
>;

export const getNonsensitiveOnlySchema = <TSchema extends StandardSchemaV1>(
  schema: TSchema,
  processor = valibotRetrieveNonsensitiveOnlySchema,
): NonsensitiveOnlySchema<TSchema> => {
  return processor(schema) as NonsensitiveOnlySchema<TSchema>;
};
export const getAllSchema = <TSchema extends StandardSchemaV1>(
  schema: TSchema,
): AllSchema<TSchema> => {
  return schema as AllSchema<TSchema>;
};

export const prepareSchema = <TSchema extends StandardSchemaV1>(
  schema: TSchema,
): {
  nonsensitiveOnlySchema: NonsensitiveOnlySchema<TSchema>;
  allsSchema: AllSchema<TSchema>;
} => {
  return {
    nonsensitiveOnlySchema: getNonsensitiveOnlySchema(schema),
    allsSchema: getAllSchema(schema),
  };
};
